'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './SliderCard.module.scss';
import Button, { ButtonType } from '../../../../components/Button/Button';
import { mediaPath } from '@/mediaPath';

export interface SliderCardProps {
  className?: string;
}

export type SlidesType = {
  title: string;
  subtitle: string;
  id: number;
  button: {
    id: number;
    link: string;
    title: string;
    type: ButtonType;
    target: '_self' | '_blank' | string;
  };
  background: {
    id: number;
    url: string;
  };
};

const SliderCard = ({
  className = '',
  data,
}: {
  data: SlidesType;
  className?: string;
}) => {
  const cardClasses = clsx(
    styles.sliderCard,
    className,
  );

  return (
    <div
      className={cardClasses}
      style={{ backgroundImage: `url(${mediaPath(data.background.url)})` }}
    >
      <div className={styles.content}>
        <h4 className={styles.heading}>{data.title}</h4>
        <p className={styles.text}>{data.subtitle}</p>
        {data.button && (
          <Button
            type={data.button.type}
            iconName='arrow_forward'
            className={styles.button}
            href={data.button.link}
            target={data.button.target}
          >
            {data.button.title}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SliderCard;
